@if (isLoading) {
  <app-chart-loading/>
} @else {
  <p-table [value]="data" [styleClass]="styleClass"
           [tableStyle]="{'width':'100%'}"
           [paginator]="!!config.pageSize" [rows]="config.pageSize || 10"
           [showCurrentPageReport]="true"
           currentPageReportTemplate="{first}–{last} de {totalRecords}"
           [lazy]="lazy" [lazyLoadOnInit]="false"
           [totalRecords]="lazy ? totalRecords : data.length"
           (onLazyLoad)="onTableLazyLoad($event)"
           [loading]="isLazyLoading" [dataKey]="dataKey"
           [selectionMode]="selectionMode === 'none' ? null : selectionMode"
           [metaKeySelection]="metaKeySelection" [selection]="selection"
           (selectionChange)="onSelectionChange($event)"
           (onRowSelect)="rowSelect.emit($event)"
           (onRowUnselect)="rowUnselect.emit($event)"
           (onHeaderCheckboxToggle)="headerCheckboxToggle.emit($event)">

    <ng-template pTemplate="header">
      <tr>
        @if (showSelectionColumn && selectionMode === 'multiple') {
          <th style="width: 3.5rem" class="text-center">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
        } @else if (showSelectionColumn && selectionMode === 'single') {
          <th style="width: 3.5rem" class="text-center"></th>
        }
        @for (col of columns; track $index) {
          @if (col.sortable) {
            <th [pSortableColumn]="col.field" [ngClass]="col.cssClass">
              {{ col.header }}
              <p-sortIcon [field]="col.field" />
            </th>
          } @else {
            <th [ngClass]="col.cssClass">{{ col.header }}</th>
          }
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" [ngClass]="{'dash-table-new-row': row.isNew}">
        @if (showSelectionColumn && selectionMode === 'multiple') {
          <td class="text-center">
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
        } @else if (showSelectionColumn && selectionMode === 'single') {
          <td class="text-center">
            <p-tableRadioButton [value]="row"></p-tableRadioButton>
          </td>
        }
        @for (col of columns; track $index) {
          <td [ngClass]="col.cssClass">
            @switch (col.type) {
              @case ('dot') {
                <div class="dot-row">
                  <span class="dot-container">
                    <span class="dot" [ngClass]="row[asDot(col).rowClass]"></span>
                  </span>
                  <span class="dot-text">{{ row[col.field] }}</span>
                </div>
              }
              @case ('text') {
                <span [ngClass]="asText(col).rowClass ? row[(asText(col).rowClass || '')] : null"
                      [style.fontWeight]="asText(col).rowClass ? 900 : null">
                  {{ row[col.field] }}
                </span>
              }
              @case ('progress') {
                <div class="eff">
                  <b>{{ row[col.field] }}{{ asProgress(col).suffix || '%' }}</b>
                  <div class="track">
                    <div class="fill" [style.width.%]="barWidth(row[col.field], asProgress(col).maxValue)"
                         [ngClass]="row[asProgress(col).rowClass]">
                    </div>
                  </div>
                </div>
              }
              @case ('pill') {
                <div class="dash-pills">
                  <span class="dash-pill">{{ row[col.field] }}</span>
                </div>
              }
              @case ('withSubtext') {
                {{ row[col.field] }}
                <br>
                <span class="dash-subtext">{{ row[asWithSubtext(col).subtextField] }}</span>
              }
              @case ('badge') {
                <div style="display:flex;align-items:center;gap:8px">
                  <span
                    [style]="{width:'32px',height:'32px',borderRadius:'8px',display:'inline-flex',alignItems:'center',justifyContent:'center',background:row[asBadge(col).bgColorField],color:row[asBadge(col).textColorField],fontWeight:'900',fontSize:'10px',flexShrink:'0'}">{{
                      row[asBadge(col).labelField]
                    }}</span>
                  <span>
                    {{ row[col.field] }}
                    @if (asBadge(col).subtextField) {
                      <br>
                      <span class="dash-subtext">{{ row[(asBadge(col).subtextField || '')] }}</span>
                    }
                  </span>
                </div>
              }
            }
          </td>
        }
      </tr>
    </ng-template>

    @if (config.total) {
      <ng-template pTemplate="footer">
        <tr class="total-row">
          @if (showSelectionColumn && selectionMode !== 'none') {
            <td></td>
          }
          <td [ngClass]="columns[0].cssClass">{{ config.total[(columns[0].field)] || config.totalLabel || 'TOTAL GENERAL' }}</td>
          @for (col of (columns | slice:1); track col.field) {
            <td [ngClass]="col.cssClass">
              @switch (col.type) {
                @case ('pill') {
                  @if (config.total[col.field]) {
                    <span class="dash-pill">{{ config.total[col.field] }}</span>
                  }
                }
                @default {
                  {{ config.total[col.field] }}
                }
              }
            </td>
          }
        </tr>
      </ng-template>
    }
  </p-table>
}
